import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LegalRepresentativeModel } from "src/app/Model/LegalRepresentative.model";
import { PartnersModel } from "src/app/Model/Partners.model";
import { RequestIdentificationModel } from "src/app/Model/RequestIdentification.model";
import { BaseService } from "../Base/BaseService";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";

@Injectable({
    providedIn: 'root'
  })
  export class RequestUpdateService extends BaseService{
    constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) { 
      super(http, lsService,authService);
        this.Component = "RequestUpdateService";
      }

      public async getIataIdentification(data) {
        let request: RequestIdentificationModel;
        await this.PostData(data, "RequestUpdate", "GetAgencyIdentification").then((res) => {
          if (res.head.status != 'False') {
            request = JSON.parse(res.body.response);
          }
        });
        return request;
      }

      public async getIataRepresentative(data) {
        let request: LegalRepresentativeModel;
        await this.PostData(data, "RequestUpdate", "GetAgencyRepresentative").then((res) => {
          if (res.head.status != 'False') {
            request = JSON.parse(res.body.response);
          }
        });
        return request;
      }

      public async getIataPartners(data) {
        let request: PartnersModel[];
        await this.PostData(data, "RequestUpdate", "GetAgencyPartners").then((res) => {
          if (res.head.status != 'False') {
            request = JSON.parse(res.body.response);
          }
        });
        return request;
      }
  }